import { XOR } from 'ts-essentials';

export enum AutomationActivityType {
  AUTOMATION_STARTED = 'AUTOMATION_STARTED',
  AUTOMATION_FINISHED = 'AUTOMATION_FINISHED',
  AUTOMATION_CONDITION_NODE_VISITED = 'AUTOMATION_CONDITION_NODE_VISITED',
  AUTOMATION_WAIT_NODE_VISITED = 'AUTOMATION_WAIT_NODE_VISITED',
  AUTOMATION_REPLY_NODE_VISITED = 'AUTOMATION_REPLY_NODE_VISITED',
  AUTOMATION_TAG_NODE_VISITED = 'AUTOMATION_TAG_NODE_VISITED',
  AUTOMATION_QUEUE_NODE_VISITED = 'AUTOMATION_QUEUE_NODE_VISITED',
  AUTOMATION_CLOSE_NODE_VISITED = 'AUTOMATION_CLOSE_NODE_VISITED',
  AUTOMATION_STOP_NODE_VISITED = 'AUTOMATION_STOP_NODE_VISITED',
  AUTOMATION_BUSINESS_HOURS_NODE_VISITED = 'AUTOMATION_BUSINESS_HOURS_NODE_VISITED',
  AUTOMATION_EXTERNAL_INTEGRATION_NODE_VISITED = 'AUTOMATION_EXTERNAL_INTEGRATION_NODE_VISITED',
}

type BaseAutomationActivity = {
  runId: string;
  eventId: string;
  eventTimestamp: string;
  csid: number;
  activityType: AutomationActivityType;
  ruleId: string;
  ruleVersion: string;
  author: string | null;
  nodeId: string;
  nextNodeId: string;
};

type TagsMutation = XOR<{ addedTagIds: string[] }, { removedTagIds: string[] }>;

export type ConditionAutomationActivity = BaseAutomationActivity & {
  isMatch: boolean;
};

export type WaitAutomationActivity = BaseAutomationActivity & {
  delayInSeconds: number;
};

export type QueueAutomationActivity = BaseAutomationActivity & {
  queueId: string;
};

export type TagAutomationActivity = BaseAutomationActivity & TagsMutation;

export type BusinessHoursAutomationActivity = BaseAutomationActivity & {
  scheduleId: string;
};
